import { Shape }              from '@tokamap/core';
import { DrawTriggerOptions } from '@tokamap/core';
import currentEditorStore     from '@/TokamapEditor/stores/currentEditorStore';
import { PLACE_LABEL_SOURCE } from '@/TokamapEditor/helpers/placeLinkedContent';
import { PLACE_IMAGE_SOURCE } from '@/TokamapEditor/helpers/placeLinkedContent';

/**
 * Retire de la forme le texte et l'image qui venaient du point d'intérêt, au moment de la délier :
 * une forme de décor qui garderait son nom et son logo passerait encore pour lui. Un texte ou une
 * image libres (détachés auparavant) appartiennent à la forme et restent. L'annulation remet le tout.
 */
export default async function unlinkPlaceContent(shapes: Shape[], options?: DrawTriggerOptions) {
	const editor = currentEditorStore.get;

	for (const shape of shapes) {
		if (shape.text?.source === PLACE_LABEL_SOURCE) {
			editor.setShapeText(shape.id, undefined, options);
		}

		if (shape.image?.source === PLACE_IMAGE_SOURCE) {
			await editor.setShapeImage(shape.id, { src: undefined, source: undefined }, options);
		}
	}
}
